import store from '@/store/store';
import {MAINTENANCE_NOTIFY_HEADER, MAINTENANCE_REDIRECT_HEADER, parseHeader} from '@/services/maintenance';

export default {
  namespaced: true,
  state: {
    maintenance: undefined
  },
  mutations: {
    set (state, value) {
      state.maintenance = value;
    }
  },
  getters: {
    get (state) {
      return state.maintenance;
    }
  },
  actions: {
    ping () {
      return fetch(`${process.env.VUE_APP_IDENTITY_API}/ping`, {
        method: 'HEAD',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include'
      }).then(res => {
        if (res.status === 503) {
          if (window.location.pathname !== '/maintenance') {
            window.location.pathname = '/maintenance';
          }
        } else {
          const allHeaders = res.headers;
          if (allHeaders.has(MAINTENANCE_NOTIFY_HEADER) && !!allHeaders.get(MAINTENANCE_NOTIFY_HEADER)) {
            store.commit('maintenance/set', parseHeader(allHeaders.get(MAINTENANCE_NOTIFY_HEADER)));
          }
          if (allHeaders.has(MAINTENANCE_REDIRECT_HEADER)  && !!allHeaders.get(MAINTENANCE_REDIRECT_HEADER)) {
            store.commit('maintenance/set', parseHeader(allHeaders.get(MAINTENANCE_REDIRECT_HEADER)));
            if (window.location.pathname !== '/maintenance') {
              window.location.pathname = '/maintenance';
            }
          }
          if (!allHeaders.has(MAINTENANCE_NOTIFY_HEADER) && !allHeaders.has(MAINTENANCE_REDIRECT_HEADER)) {
            store.commit('maintenance/set', null);
          }
        }
        return res;
      });
    }
  }
};
